import { CodespacesIcon, TasklistIcon } from "@primer/octicons-react";
import { Box, UnderlineNav } from "@primer/react";
import { useState } from "react";
import HinhThucMienGiamPage from "./HinhThucMienGiamPage";
import HinhThucMienGiamGroupPage from "./nhom-mien-giam";

const HinhThucMienGiamLayout = () => {
    const [selectedTab, setSelectedTab] = useState<"nhommiengiam" | "hinhthucmiengiam">("nhommiengiam");

    return (
        <Box>
            <UnderlineNav aria-label="tabs">

                <UnderlineNav.Item
                    icon={TasklistIcon}
                    aria-current={selectedTab === "nhommiengiam" ? "page" : undefined}
                    onClick={() => setSelectedTab("nhommiengiam")}
                >
                    Nhóm miễn giảm
                </UnderlineNav.Item>
                <UnderlineNav.Item
                    icon={CodespacesIcon}
                    aria-current={selectedTab === "hinhthucmiengiam" ? "page" : undefined}
                    onClick={() => setSelectedTab("hinhthucmiengiam")}
                >
                    Hình thức miễn giảm
                </UnderlineNav.Item>
            </UnderlineNav>
            <Box>
                {selectedTab === "nhommiengiam" &&
                    <HinhThucMienGiamGroupPage />
                }
            </Box>
            <Box>
                {selectedTab === "hinhthucmiengiam" &&
                    <HinhThucMienGiamPage />
                }
            </Box>
        </Box>
    );
};

export default HinhThucMienGiamLayout;
